import { Component, input } from '@angular/core';
import { HintIcon } from '../../hint-icon/hint-icon';

@Component({
  selector: 'app-form-field-wrapper',
  imports: [HintIcon],
  templateUrl: './form-field-wrapper.html',
})
export class FormFieldWrapper {
  readonly fieldName = input.required<string>();
  readonly hint = input<string | null>(null);
  readonly isRequired = input<boolean>(true);
  readonly disabled = input<boolean>(false);
}
